export const getInvoiceFiles = (token) => {
    return async (dispatch) => {
        try {
            // await fetch(`${process.env.REACT_APP_API_URL}/lasir/upload_invoice`);
            const response = await fetch(`${process.env.REACT_APP_API_URL}/lasir/uploaded_invoices`, {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${token}`,

                },
            });
            const data = await response.json();
            // console.log("data", data);
            dispatch({
                type: 'GET_INVOICE_FILES',
                payload: data,
            });

        } catch (error) {
            console.log(error);
        }
    };
};
/**
 * 
 * Download Product Report 
 * 
 */
export const downloadProductReportStart = () => ({
  type: 'DOWNLOAD_PRODUCT_REPORT_START',
  payload: null
});

export const downloadProductReportSuccess = () => ({
  type: 'DOWNLOAD_PRODUCT_REPORT',
  payload: null,
});


export const downloadProductReportFailure = () => ({
  type: 'DOWNLOAD_PRODUCT_REPORT_FAILURE',
  payload: null
});
/**
 * 
 * Ger Product Detail Report 
 * 
 */
export const getProductDetailReportStart = () => ({
  type: 'GET_PRODUCT_DETAIL_REPORT_START',
  payload: null
});

export const getProductDetailReportSuccess = (data) => ({
  type: 'GET_PRODUCT_DETAIL_REPORT',
  payload: data,
});


export const getProductDetailReportFailure = (e) => ({
  type: 'GET_PRODUCT_DETAIL_FAILURE',
  payload: e
});

export const getProductDetailReport = (prefix_invoice, invoice_number, type='download', token) => {
  return async (dispatch) => {
      try {
        downloadProductReportStart()
          const response = await fetch(`${process.env.REACT_APP_API_URL}/lasir/invoice_detail?type=${type}`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,

              },
              body: JSON.stringify({
                prefix_invoice, 
                invoice_number
            })
          });
          if(type === 'download') {

            const blob = await response.blob();
            // Create a URL for the Blob
            const url = window.URL.createObjectURL(blob);
  
            // Create a temporary link and click on it to download the file
            const link = document.createElement('a');
            link.href = url;
            link.download = `${prefix_invoice}${invoice_number}.xlsx`;
            link.style.display = 'none'; // Hide the link element
            document.body.appendChild(link); // Add the link to the DOM
            link.click();
            // Clean up
            document.body.removeChild(link); // Remove the link from the DOM
            window.URL.revokeObjectURL(url);
            await downloadProductReportSuccess()

          } else {
            try {
              const data = await response.json();
              console.log("data", data);
              dispatch({
                type: 'GET_PRODUCT_DETAIL_REPORT',
                payload: data,
              })
              console.log("data2", data);
            } catch (e) {
              dispatch(getProductDetailReportFailure(e))
            }
           
          }


      } catch (error) {
          console.log(error);
          await downloadProductReportFailure()

      }
  };
};

export const fetchData = () => ({
    type: 'UPLOAD_INVOICE_FILE',
  
  });
  
  export const fetchDataSuccess = (data) => ({
    type: 'UPLOAD_INVOICE_FILE_SUCCESS',
    payload: data,
  });
  
  
  export const fetchDataFailure = (error) => ({
    type: 'UPLOAD_INVOICE_FILE_FAILURE',
    payload: error
  });

export const uploadInvoice = (formData, token) => {

    return async(dispatch) => {
        try {
          // console.log("Start");
          dispatch(fetchData())
          // console.log("Fetch");
  
          const response = await fetch(`${process.env.REACT_APP_API_URL}/lasir/generic_invoice`, {
            method: 'POST',
            body: formData,
            headers: {
              'Authorization': `Bearer ${token}`,
            },
          });
    
          if (response.ok) {
            const data = await response.json();
            // console.log("Data", data);
            dispatch(fetchDataSuccess(data))
            // console.log('File uploaded successfully');
            // Perform any additional actions after successful upload
          } else {
            const errorData = await response.json();
            dispatch(fetchDataFailure(errorData))
            console.log("error");
  
            console.error('Error uploading file:', response.status, errorData);        }
          } catch (error) {
          console.error('Error uploading file:', error);
          dispatch(fetchDataFailure("Error inesperado"))
          console.log("error");
  
        }
       
    };
};


